import React from 'react';
import { MobileStepper, LinearProgress, Typography, Box } from '@mui/material';
import { colors } from '../../styles/fontStyles';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

interface CustomStepperProps {
  steps: number;
  activeStep: number;
  children?: React.ReactNode;
}

const CustomStepper = ({ steps, activeStep, children }: CustomStepperProps) => {
  const { theme } = useThemeContext();
  const progress = (activeStep / steps) * 100;

  const renderChildren = () => {
    if (!children) return;

    return <>{children}</>;
  };

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      {renderChildren()}
      <MobileStepper
        variant="progress"
        steps={steps}
        activeStep={activeStep}
        sx={{
          flexGrow: 1,
          bgcolor: 'transparent',
          marginBottom: '30px',
        }}
        backButton={null}
        nextButton={null}
        LinearProgressProps={{
          sx: { display: 'none' },
        }}
      />
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 3,
          backgroundColor: theme.custom.components.customStepper.backgroundColor,
          borderRadius: 5,
          '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            backgroundColor: theme.custom.components.customStepper.progressBar.backgroundColor,
          },
        }}
      />
    </Box>
  );
};

export default CustomStepper;
